import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-compare-capgo-advantages-section',
  imports: [SectionHeaderComponent, TuiIcon],
  templateUrl: './compare-capgo-advantages-section.component.html',
  styleUrl: './compare-capgo-advantages-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompareCapgoAdvantagesSectionComponent {}
